import React, { useState, useEffect } from 'react';

const YearDropdown = ({ handleInputChange, name, errors, selectedYear }) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i);
  const [year, setYear] = useState(selectedYear || "year");

  useEffect(() => {
    setYear(selectedYear || "year");
  }, [selectedYear]);

  const handleYearChange = (e) => {
    setYear(e.target.value);
    handleInputChange(e);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <select
        id="field-2"
        name={name}
        data-name={name}
        className="select-field-3 w-select"
        style={{ width: '100%' }}
        onChange={handleYearChange}
        value={year}
      >
        <option value="Year">Year</option>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
      {errors && (
        <div className="error-message" style={{ color: '#CB112D',  width: '100%' }}>
          {errors}
        </div>
      )}
    </div>
  );
};

export default YearDropdown;
